import toastr from "toastr";
import "toastr/build/toastr.min.css";

export const showMessage = (type, message, onHidden, onShown) => {
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onShown: onShown,
    onHidden: onHidden,
  };
  toastr[type](message);
};

export const showToast = (value, type, onHidden, onShown) => {
  if (value) {
    switch (Object.prototype.toString.call(value)) {
      case "[object String]":
        showMessage(type, value, onHidden, onShown);
        break;
      case "[object Array]":
        value.map((e) => showMessage(type, e?.value ?? e, onHidden, onShown));
        break;
      case "[object Object]":
        Object.values(value).map((e) =>
          showMessage(type, e?.value ?? e, onHidden, onShown)
        );
        break;
      default:
        showMessage(type, value, onHidden, onShown);
        break;
    }
  }
};
